module.exports = __webpack_public_path__ + "img/STERiJECT_02_3.b8be79fe.png";